/**
 * BNZ Affiliate Popup
 * Affiche une popup de bienvenue personnalisée pour les visiteurs affiliés
 * Extraction automatique du code depuis l'URL - aucun mapping requis
 */
(function () {
  'use strict';

  var SESSION_KEY = 'bnz_affiliate_popup_shown';
  var REDIRECT_KEY = 'bnz_affiliate_discount_redirect';
  var PENDING_KEY = 'bnz_affiliate_pending';

  function log(popup, msg, data) {
    if (popup && popup.getAttribute('data-debug') === 'true' && typeof console !== 'undefined' && console.log) {
      console.log('[BNZ Affiliate Popup]', msg, data !== undefined ? data : '');
    }
  }

  function parseUrl() {
    var search = window.location.search || '';
    var pathname = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var params = {};

    if (search) {
      search.slice(1).split('&').forEach(function (pair) {
        var parts = pair.split('=');
        if (parts[0]) {
          params[decodeURIComponent(parts[0])] = decodeURIComponent((parts[1] || '').replace(/\+/g, ' '));
        }
      });
    }

    return { params: params, pathname: pathname };
  }

  function isOnDiscountPath(pathname) {
    var m = (pathname || '').match(/^\/discount\/([A-Z0-9]{4,20})$/i);
    return m && /\d/.test(m[1]);
  }

  function isSameSiteReferrer(ref) {
    if (!ref) return false;
    try {
      var refUrl = new URL(ref);
      var ourHost = (window.location.hostname || '').toLowerCase();
      var refHost = (refUrl.hostname || '').toLowerCase();
      if (refHost === ourHost) return true;
      if (refHost.endsWith('.' + ourHost) || ourHost.endsWith('.' + refHost)) return true;
      var ourRoot = ourHost.replace(/^www\./, '');
      var refRoot = refHost.replace(/^www\./, '');
      return ourRoot === refRoot;
    } catch (e) {
      return false;
    }
  }

  function getCodeFromReferrer() {
    var ref = typeof document.referrer === 'string' ? document.referrer : '';
    if (!ref || !isSameSiteReferrer(ref)) return null;
    var m = ref.match(/\/discount\/([A-Z0-9]{4,20})/i);
    if (m && /\d/.test(m[1])) return m[1].toUpperCase();
    try {
      var url = new URL(ref);
      var segments = url.pathname.replace(/\/$/, '').split('/').filter(Boolean);
      for (var i = 0; i < segments.length; i++) {
        var seg = segments[i];
        if (seg === 'fr' || seg === 'en' || seg.length === 2) continue;
        if (/^[A-Z0-9]{4,20}$/i.test(seg) && /\d/.test(seg)) return seg.toUpperCase();
      }
    } catch (e) {}
    return null;
  }

  function getCodeFromUtmHeuristic(utmContent, utmCampaign) {
    if (!utmContent || !utmCampaign) return null;
    var base = (utmContent.split('_')[0] || utmContent).replace(/[^a-z0-9]/gi, '').toUpperCase();
    var numMatch = utmCampaign.match(/(\d{1,3})/);
    var num = numMatch ? numMatch[1] : null;
    if (!base || !num) return null;
    return base + num;
  }

  function getPendingFromSessionStorage() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function getCode(urlData) {
    var code = urlData.params.code || urlData.params.discount || urlData.params.ref;
    if (code) return code.toUpperCase().trim();

    var segments = urlData.pathname.split('/').filter(Boolean);
    for (var i = 0; i < segments.length; i++) {
      var seg = segments[i];
      if (seg === 'fr' || seg === 'en' || seg.length === 2) continue;
      if (seg === 'discount' && segments[i + 1]) {
        var next = segments[i + 1];
        if (/^[A-Z0-9]{4,20}$/i.test(next) && /\d/.test(next)) return next.toUpperCase();
      }
      if (/^[A-Z0-9]{4,20}$/i.test(seg) && /\d/.test(seg)) return seg.toUpperCase();
    }

    var first = segments[0];
    if (first && /^[A-Z0-9]{4,20}$/i.test(first) && /\d/.test(first)) return first.toUpperCase();

    code = getCodeFromReferrer();
    if (code) return code;

    if (urlData.params.utm_medium === 'affiliate' || urlData.params.dt_id) {
      code = getCodeFromUtmHeuristic(urlData.params.utm_content, urlData.params.utm_campaign);
      if (code) return code;
      var utmCampaign = urlData.params.utm_campaign;
      var utmSource = urlData.params.utm_source;
      var codePattern = /^[A-Z0-9]{4,20}$/i;
      if (utmCampaign && codePattern.test(utmCampaign) && /\d/.test(utmCampaign)) return utmCampaign.toUpperCase();
      if (utmSource && codePattern.test(utmSource) && /\d/.test(utmSource)) return utmSource.toUpperCase();
    }

    var pending = getPendingFromSessionStorage();
    if (pending && pending.code) return pending.code;

    return null;
  }

  function getPercentage(code) {
    if (!code) return null;
    var match = code.match(/(\d{1,3})$/);
    return match ? parseInt(match[1], 10) : null;
  }

  function formatCreatorName(raw) {
    if (!raw) return null;
    // Retire un préfixe technique "ID-" / "ID_" (ex: ID-RAPHAELLEBAUDEN), gère tirets et underscores
    var cleaned = String(raw).replace(/^id[-_]/i, '').replace(/[-_]+/g, ' ').trim();
    if (!cleaned) return null;
    return cleaned
      .toLowerCase()
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  // Nom du créateur : utm_content en priorité (ancien système), sinon utm_campaign (programme communauté, ex: ID-RAPHAELLEBAUDEN)
  function getCreatorName(urlData, pending) {
    var content = urlData.params.utm_content || (pending && pending.utm_content) || '';
    if (content) return formatCreatorName(content);
    var campaign = urlData.params.utm_campaign || (pending && pending.utm_campaign) || '';
    // On n'utilise utm_campaign comme nom que s'il ressemble à un libellé (préfixe ID- ou présence de lettres + séparateur), pas à un code promo brut
    if (campaign && (/^id[-_]/i.test(campaign) || /[a-z].*[-_]/i.test(campaign))) {
      return formatCreatorName(campaign);
    }
    return null;
  }

  // Clé de correspondance : on retire le préfixe "ID-", tout séparateur et la casse.
  // Ex : "ID-RAPHAELLEBAUDEN" (URL) et "raphaelle-bauden" (métaobjet) → tous deux "RAPHAELLEBAUDEN".
  function normalizeKey(raw) {
    if (!raw) return '';
    return String(raw).replace(/^id[-_]/i, '').replace(/[^a-z0-9]/gi, '').toUpperCase();
  }

  // Table des créateurs affiliés, rendue par la section depuis le métaobjet (JSON inline).
  // Retourne { CLE_NORMALISEE: { name: 'Nom Affiché', percent: 15|null } } ou null.
  function getCreatorMap() {
    var el = document.getElementById('bnz-affiliate-creators');
    if (!el) return null;
    var data;
    try { data = JSON.parse(el.textContent || '[]'); } catch (e) { return null; }
    if (!data || !data.length) return null;
    var map = {};
    for (var i = 0; i < data.length; i++) {
      var entry = data[i] || {};
      var key = normalizeKey(entry.handle);
      if (!key) continue;
      var pct = (entry.percent === '' || entry.percent == null) ? null : parseInt(entry.percent, 10);
      map[key] = {
        name: entry.name ? String(entry.name).trim() : null,
        percent: (pct == null || isNaN(pct)) ? null : pct
      };
    }
    return map;
  }

  // Cherche un créateur dans la table à partir d'utm_campaign puis utm_content (URL ou persisté).
  function lookupCreator(map, urlData, pending) {
    if (!map) return null;
    var sources = [
      urlData.params.utm_campaign || (pending && pending.utm_campaign),
      urlData.params.utm_content || (pending && pending.utm_content)
    ];
    for (var i = 0; i < sources.length; i++) {
      var key = normalizeKey(sources[i]);
      if (key && map[key]) return map[key];
    }
    return null;
  }

  // Visite affiliée = signal Collabs présent (dt_id ou utm_medium=affiliate), dans l'URL ou persisté
  function isAffiliateVisit(urlData, pending) {
    if (urlData.params.dt_id) return true;
    if (urlData.params.utm_medium === 'affiliate') return true;
    if (pending && pending.utm_medium === 'affiliate') return true;
    if (pending && pending.dt_id) return true;
    return false;
  }

  function shouldShow(urlData, code, pending) {
    if (isAffiliateVisit(urlData, pending)) return true;
    if (code) return true;
    return false;
  }

  function cameFromDiscountOrCollabs(urlData) {
    if (urlData && urlData.params.dt_id) return true;
    if (urlData && urlData.params.utm_medium === 'affiliate') return true;
    if (urlData && urlData.params.utm_source === 'collabs') return true;
    var ref = typeof document.referrer === 'string' ? document.referrer : '';
    if (ref.indexOf('/discount/') !== -1) return true;
    var code = getCodeFromReferrer();
    return !!code;
  }

  function init() {
    var popup = document.getElementById('bnz-affiliate-popup');
    if (!popup) return;

    if (typeof window.isB2B === 'boolean' && window.isB2B) return;

    var urlData = parseUrl();
    var pending = getPendingFromSessionStorage();
    var urlCode = getCode(urlData);           // code chiffré présent dans l'URL/referrer (ancien système), sinon null
    var code = urlCode;
    var percentage = urlCode ? getPercentage(urlCode) : null;

    // Programme communauté : lien affilié sans code chiffré dans l'URL (ex: /prenom-nom → home + code général).
    // Si la visite est affiliée mais qu'aucun % n'est détecté, on applique le code/% par défaut configurés.
    if (percentage === null && isAffiliateVisit(urlData, pending)) {
      code = (popup.getAttribute('data-default-code') || 'MMMCOMMUNAUTE15').toUpperCase().trim();
      var defPct = parseInt(popup.getAttribute('data-default-percent'), 10);
      percentage = isNaN(defPct) ? 15 : defPct;
      log(popup, 'Repli programme communauté', { code: code, percentage: percentage });
    }

    // Table créateurs (métaobjet) : override du nom + du % si le créateur y figure.
    var mapped = lookupCreator(getCreatorMap(), urlData, pending);
    if (mapped && mapped.percent != null) {
      percentage = mapped.percent;
      log(popup, 'Override % via métaobjet', percentage);
    }

    if (!code || percentage === null) return;

    if (!shouldShow(urlData, code, pending)) return;

    if (sessionStorage.getItem(SESSION_KEY)) return;

    var needsRedirect = !isOnDiscountPath(urlData.pathname) && !cameFromDiscountOrCollabs(urlData) && !sessionStorage.getItem(REDIRECT_KEY);
    if (needsRedirect) {
      var currentUrl = window.location.pathname + window.location.search;
      var discountUrl = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(currentUrl);
      sessionStorage.setItem(REDIRECT_KEY, '1');
      log(popup, 'Redirect vers /discount/ pour appliquer le code', discountUrl);
      window.location.href = discountUrl;
      return;
    }

    // Nom : le métaobjet (saisi proprement) prime, sinon extraction auto depuis l'URL.
    var creatorName = (mapped && mapped.name) || getCreatorName(urlData, pending);
    var collectionsUrl = popup.getAttribute('data-collections-url') || '/collections/all';

    // CTA :
    //  - Ancien système (vrai code chiffré dans l'URL) → on ré-applique le code via /discount/.
    //  - Programme communauté → la bonne réduction est DÉJÀ appliquée par Collabs ; on n'en ré-applique
    //    aucune pour ne jamais risquer de « rabaisser » un % (ex. 20 → 15). On envoie juste vers la boutique.
    var ctaHref = urlCode
      ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(collectionsUrl)
      : collectionsUrl;

    var percentEls = popup.querySelectorAll('[data-percent], [data-percent-cta]');
    for (var i = 0; i < percentEls.length; i++) {
      percentEls[i].textContent = String(percentage);
    }

    var creatorEl = popup.querySelector('[data-creator-name]');
    if (creatorEl) {
      creatorEl.textContent = creatorName || 'notre partenaire';
    }

    var ctaLink = popup.querySelector('[data-cta-link]');
    if (ctaLink) {
      ctaLink.href = ctaHref;
    }

    var showDelay = parseInt(popup.getAttribute('data-show-delay'), 10) || 800;

    function show() {
      popup.removeAttribute('hidden');
      popup.setAttribute('aria-hidden', 'false');
      popup.classList.add('is-visible');
      sessionStorage.setItem(SESSION_KEY, '1');
      try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
    }

    function hide() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('hidden', '');
    }

    log(popup, 'Affichage dans', showDelay + 'ms');
    var timeoutId = setTimeout(show, showDelay);

    function onClose() {
      clearTimeout(timeoutId);
      hide();
    }

    var backdrop = popup.querySelector('.bnz-affiliate-popup__backdrop');
    if (backdrop) backdrop.addEventListener('click', onClose);

    var closeBtn = popup.querySelector('.bnz-affiliate-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', onClose);

    document.addEventListener('keydown', function onEscape(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        onClose();
        document.removeEventListener('keydown', onEscape);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
